import React, { FunctionComponent } from 'react'
import { IconSizes, PaymentIcon, Span, Text } from '@afterpaytouch/core'
import styles from './style.module.css'
import clsx from 'clsx'
import { useCheckoutSizes } from '../../utils/responsive'
import { useApplePayFeature } from '../../state'
import { useCheckoutColor } from '../../utils/color'
import { useTranslation } from '../../utils/convergence'

interface Props {
  iconSize?: IconSizes
  reversed?: boolean
  showLearnMore?: boolean
  handleToggleTooltip?: () => void
  tooltipRef?: any
  testNameSpace?: string
  validatePaymentType?: boolean
  ariaDescribedBy?: string
}

export const PaymentMethodApplePayRedesigned: FunctionComponent<Props> = ({
  showLearnMore = false,
  handleToggleTooltip = () => {},
  testNameSpace = '',
  validatePaymentType = false,
  ariaDescribedBy = '',
}) => {
  const { t } = useTranslation()
  const { textSize, smallTextSize } = useCheckoutSizes()
  const applePay = useApplePayFeature()
  const { textColor, subtextColor } = useCheckoutColor({ hasError: !applePay.enabledForConsumerLending && validatePaymentType })
  const tooltipButtonClasses = clsx(styles.triggerButton, styles.arcadeExperiment)

  const isApplePayNotAllowed = !applePay.enabledForConsumerLending && validatePaymentType
  return (
    <span className={styles.applepayContainerNew} {...(testNameSpace.length > 0 && { 'data-testid': testNameSpace })}>
      <span className={styles.icon}>
        <PaymentIcon name='Applepay' size='Large' title={t('paymentMethod:applePay')} />
      </span>
      <span className={styles.applepayContentContainer}>
        <Span bold size={textSize} color={textColor}>
          {t('paymentMethod:applePay')}
        </Span>
        <Span size={textSize} color={subtextColor}>
          {t('paymentMethod:applePayDescription')}
        </Span>
        {isApplePayNotAllowed && (
          <Span size={smallTextSize} color='Fire'>
            {t(`paymentMethod:errors.applePayNotAllowed`)}
          </Span>
        )}
        {showLearnMore && (
          <button type='button' className={tooltipButtonClasses} onClick={handleToggleTooltip} aria-describedby={ariaDescribedBy}>
            <Text size={textSize} bold renderAs='span' underline>
              {t('paymentMethod:learnMore')}
            </Text>
          </button>
        )}
      </span>
    </span>
  )
}
